export default "__VITE_ASSET__2ba7a3be__"